module.exports = __webpack_public_path__ + "img/download_on_the_appgallery.9db928c9.svg";